import React from 'react';
import { MoonIcon, SunIcon } from 'lucide-react';
interface DarkModeToggleProps {
  isDarkMode: boolean;
  onToggle: () => void;
}
export const DarkModeToggle = ({
  isDarkMode,
  onToggle
}: DarkModeToggleProps) => {
  return <button onClick={onToggle} className="fixed bottom-6 right-6 h-14 w-14 rounded-full bg-gradient-to-br from-[#7FE5A8] to-[#5FD88F] dark:from-[#7FE5A8] dark:to-[#5FD88F] shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center z-50 hover:scale-110 border-2 border-transparent dark:border-white" aria-label="Toggle dark mode" data-id="element-24">
      {isDarkMode ? <SunIcon className="h-6 w-6 text-[#1A2332]" data-id="element-25" /> : <MoonIcon className="h-6 w-6 text-[#1A2332]" data-id="element-26" />}
    </button>;
};